import { useContext } from 'react';

import { TpmContext } from './TpmProvider';

/**
 * Hook to access TPM context
 *
 * New API:
 * - state: Current state (screen, phoneNumber, verificationCode, etc.)
 * - actions: Action creators (startValidation, submitCode, etc.)
 * - dispatch: Raw dispatch for custom actions
 *
 * Legacy API (for backwards compatibility):
 * - tpmNumber: [state, setState] tuple
 */
export const useTpmContext = () => {
    const context = useContext(TpmContext);

    if (!context) {
        throw new Error('useTpmContext must be used within a TpmProvider');
    }

    return context;
};

/**
 * Hook to access only the new TPM state API
 */
export const useTpmState = () => {
    const { state } = useTpmContext();
    return state;
};

/**
 * Hook to access only the TPM actions
 */
export const useTpmActions = () => {
    const { actions } = useTpmContext();
    return actions;
};
